<template>
  <div class="fixed-bottom sc-toast">
    <transition name="fade" mode="out-in">
      <div class="container mb-4 d-flex justify-content-center" v-if="message">
        <Alert :class="type" :title="message" :icon="icon">
          <p class="m-0" v-if="swButtons">
            <a class="cursor-pointer alert-link" @click="update">Refresh &amp; Update</a>
            <a class="cursor-pointer ml-3 alert-link" @click="clear">Cancel</a></p>
        </Alert>
      </div>
    </transition>
  </div>
</template>

<script>
import { EventBus } from '@/utils/event-bus'

export default {
  data: function () {
    return {
      icon: null,
      message: false,
      swButtons: false,
      type: null
    }
  },
  mounted: function () {
    EventBus.$on('toast:show', this.handle)
  },
  beforeDestroy: function () {
    EventBus.$off('toast:show', this.handle)
  },
  methods: {
    update: function () {
      EventBus.$emit('toast:showSwUpdate:update')
    },
    handle: function (method) {
      this[method]()
    },
    showSwUpdate: async function () {
      this.show('A new version of Superchargify Dashboard is available!', {
        icon: 'IconBolt',
        swButtons: true,
        type: 'alert-info'
      })
    },
    showSaving: async function () {
      this.show('Saving your changes...', {
        icon: 'IconEdit',
        swButtons: false,
        type: 'alert-info'
      })
    },
    showSaved: async function () {
      this.show('Your changes were saved successfully!', {
        timeout: 2000,
        icon: 'IconCheck',
        swButtons: false,
        type: 'alert-info'
      })
    },
    showInvalidImageTypeError: async function () {
      this.show('This image type is not supported. Please use png, jpeg, svg or gif.', {
        timeout: 3000,
        icon: 'IconImportant',
        swButtons: false,
        type: 'alert-danger'
      })
    },
    pleaseWait: function () {
      this.show('Please wait while we load.', {
        timeout: 1800,
        icon: 'IconImportant',
        swButtons: false,
        type: 'alert-info'
      })
    },
    show: async function (message, config = {}) {
      await this.clear()

      this.message = message

      const { timeout, icon, swButtons, type } = config

      if (timeout) {
        setTimeout(this.clear, timeout)
      }

      this.icon = icon
      this.swButtons = swButtons
      this.type = type
    },
    clear: async function () {
      this.message = false
      await this.$nextTick()
    }
  }
}
</script>

<style lang="scss">
.sc-toast {
  @media (max-width: 52rem) {
    bottom: 90px!important;
  }

  .alert {
    display: inline-block;
    border-top: 1px solid #bde0e3;

    a {
      font-size: 12px;
      font-weight: 500;
    }
  }
}
</style>
